import React from 'react'
import Typography from 'material-ui/Typography'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import IconButton from 'material-ui/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Grid from 'material-ui/Grid'
import Button from 'material-ui/Button'
import { withStyles } from 'material-ui/styles'
import ClientForm from '../components/ClientForm'
import VehiclesForm from '../../vehicles/components/VehiclesForm'

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
  formSection: {
    marginTop: 50
  }
})

const NewClient = ({ handleChange, values, classes, handleClose, save, errors }) =>
  <React.Fragment>
    <AppBar className={classes.appBar}>
      <Toolbar>
        <IconButton color="inherit" onClick={handleClose} aria-label="Close">
          <CloseIcon />
        </IconButton>
        <Typography variant="title" color="inherit" className={classes.flex}>
          New Customer
        </Typography>
        <Button color="inherit" onClick={() => {
          save(values).then(handleClose)
        }}>
          save
        </Button>
      </Toolbar>
    </AppBar>
    <Grid container>
      <Grid container alignContent='center' alignItems='center' justify='center' direction='column'>
        <Grid item xs={6}>
          <Grid className={classes.formSection} item xs={12}>
            <Typography variant='headline'>Contact Information</Typography>
            <ClientForm customer={values} handleChange={handleChange} errors={errors} />
          </Grid>
          <Grid className={classes.formSection} item xs={12}>
            <Typography variant='headline'>Vehicle Information</Typography>
            <VehiclesForm vehicle={values.vehicle} handleChange={(key, value) => handleChange(`vehicle.${key}`, value)} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </React.Fragment>

export default withStyles(styles, { withTheme: true })(NewClient)


// WEBPACK FOOTER //
// ./src/modules/clients/components/NewClient.js